import React from 'react';
import UserFlowFundsTable from './UserFlowFundsTable';
import groupsSearchItem from '../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';

const GroupsSearchItem = groupsSearchItem(UserFlowFundsTable);

export default props => (
  <GroupsSearchItem
    {...props}
    groupName="userFlowFundsHistory"
    listReduceName="userFlowFundsModule.lists.userFlowFundsByAuthUserList"
  />
);



// WEBPACK FOOTER //
// ./src/components/UserFlowFunds/UserFlowFundsHistoryTable/index.js